import React, { Dispatch, SetStateAction } from "react";
import Navigator from '../components/Navigation';
import { ArticleTextSection } from "../articleDetailPage/ArticleTextSection"
import { ProtectedArticleGroup } from "../articleDetailPage/ProtectedArticleGroup";
import { ArticleTitle } from "../articleDetailPage/ArticleTitle";
import { hashPassword, hashPasswordsFromEnv } from "../utils/passwordUtils";
import ArticleImageLayout from "../articleDetailPage/ArticleImageLayout";
import '../style.css';
import { Wavedivider } from "../components/Wavedivider";
import { CalloutLink } from "../components/CalloutLink";
import { useMetaTags } from '../utils/useMetaTags';
import image1 from '../image/articles/article4-1.webp';

import ProtectedPage from "../components/ProtectedPage";

function Essaytoyou(props: {
    activeNav: number, 
    setActiveNav: Dispatch<SetStateAction<number>>,
  }) {
      const images = [image1];
      
      const hashedPasswords = hashPasswordsFromEnv( 
        process.env.REACT_APP_ESSAYtoyou_PASSWORDS
      );
      const sectionLockHashes = hashPasswordsFromEnv(
        process.env.REACT_APP_ESSAY2605_SECTION_PASSWORDS
      );
    
      useMetaTags({
        title: '나에게 너에게 들려주고 싶은 글 - Lynkim',
        description: '좋은지 나쁜지 누가 아는가',
        image: '/ogimage.png',
      });
      
      return (
        <>
        <ProtectedPage password={hashedPasswords} description="이 글은 한 사람만 볼 수 있어요">
        <Navigator activeNav={props.activeNav} setActiveNav={props.setActiveNav} />
        <div className='fadeIn '>
            <ArticleTitle
                title={'나에게 너에게 들려주고 싶은 글'}
                titleEn={"Words I'd like to share — with myself and with you"}
                description={<div>좋은지 나쁜지 누가 아는가</div>}
                descriptionEn={<div>Who knows whether it's good or bad</div>}
                category={'essay'}
                date={'2026.05.30.'}
                thumbnail={image1}
            />
        </div>
        <Wavedivider/>
        <div className='articleLayout'>
        <ArticleTextSection
                title = '좋은지 나쁜지 누가 아는가'              
                marginBottom={true}
                description={
                  <div>
                    당신의 삶에 나타나는 사람들은<br/>
                    어떤 이유가 있어서 오는 사람, 한계절에만 등장하는 사람, <br/>
                    혹은 평생동안 만남을 갖는 사람이 있다.<br/><br/>

                    그중 어디에 속하는지 알면 저마다의 사람과 어떤 관계를 맺어야 할지 알게될 것이다. <br/>
                    어떤 이유가 있어 당신의 삶에 온 경우, 그들은 대개 당신이 드러내보인 필요를 충족해주기 위해 온다. <br/>
                    당신이 고난을 통과하도록 돕고, 길을 안내하고 지지해주려고 온다. <br/><br/>

                    그들은 신이 보낸 것처럼 보일지도 모르며 실제로도 그렇다. <br/>
                    그들은 당신이 그들을 필요로 하는 그 이유때문에 나타난 것이다. <br/><br/>

                    그들은 당신 잘못이 전혀 없는데도 혹은 좋지 않은 시기에 관계를 끝낼 것 같은 말이나 행동을 하게도 한다. <br/>
                    때로는 죽거나 어디론가 떠나버리기도 한다. <br/>
                    때로는 과격한 행동을 해서 당신이 분명한 결단을 내리게 만든다. <br/><br/>

                    이때 우리가 깨달아야 할 것은 우리의 필요가 충족되었다는 것. <br/>
                    우리가 바라던 것이 채워졌다는 것. <br/>
                    그래서 그들의 역할이 끝났다는 사실이다. <br/><br/>

                    당신이 올려보낸 기도는 응답받았으며, 이제는 앞으로 나아갈 때가 온 것이다. <br/>
                    당신이 내 삶에 나타나 준 것에 감사하다. <br/>
                    그것이 이유가 있는 만남이든, 한계절동안의 만남이든, 생애를 관통하는 만남이든. <br/><br/>

                    <b> 좋은지 나쁜지 누가 아는가 중</b>

                    
                  </div>
                }
        /></div>
        </ProtectedPage>
        </>
      )
  }

export default Essaytoyou;